import script from "./AdapButtomBlack.vue?vue&type=script&setup=true&lang=js"
export * from "./AdapButtomBlack.vue?vue&type=script&setup=true&lang=js"

import "./AdapButtomBlack.vue?vue&type=style&index=0&id=ffc5da68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffc5da68"]])

export default __exports__